<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 300px;">


        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">项目分类</div>
            <el-select v-model="bedGoodsClassCode" filterable clearable placeholder="请选择项目分类" style="width: 100%">
              <el-option
                  v-for="item in bedGoodsClassList"
                  :key="item.bedGoodsClassCode"
                  :label="item.name"
                  :value="item.bedGoodsClassCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">改造项目名称</div>
            <el-input v-model="add_Name" placeholder="请输入改造项目名称"></el-input>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_Name:'',

      bedGoodsClassList:[],
      bedGoodsClassCode:'',

    }
  },
  methods: {

    init(){
      this.add_Name = '';

      this.getClassList();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.bedGoodsClassCode === ''){
        this.$message("请选择项目分类");
        return;
      }
      if(this.add_Name === ''){
        this.$message("请输入项目名称");
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BedGoods/Add',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.add_Name,
          selectType:1,
          bedGoodsClassCode:this.bedGoodsClassCode,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    getClassList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BedGoodsClass/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.bedGoodsClassList = response.data.data;
          if(this.bedGoodsClassList.length>0){
            //this.bedGoodsClassCode = this.bedGoodsClassList[0].bedGoodsClassCode;
          }

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>


